<template>
    <div class="left-section d-flex flex-column">
        <div class="input-group">
            <input type="text" class="form-control" placeholder="" aria-label="" aria-describedby="button-addon2">
            <button class="btn btn-outline-secondary" type="button" id="button-addon2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
            </button>
        </div>
        <div class="input-group mb-3">
            <span class="input-group-text">
                案件選択
            </span>
            <select class="form-select" aria-label="lawcase selector" @change="onChangeCase" @mousedown="updateCaseList" v-model="selectedCase">
                <option v-for="lawcase in lawcases" v-bind:key="lawcase.id" :value="lawcase.id"> {{lawcase.name}} </option>
            </select>
            <!-- modal -->
            <!-- Button trigger modal -->
            <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#newLawcaseDialog">+</button>
            <!-- Modal -->
            <div class="modal fade" id="newLawcaseDialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content p-3">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">案件作成</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="input-group mb-0">
                    <span class="input-group-text">案件名</span>
                    <input type="text" class="form-control" placeholder="新規案件名" aria-label="new case name" v-model="newLawcaseName">
                  </div>
                  <div class="input-group">
                    <span class="input-group-text" >フォルダ名</span>
                    <input type="text" class="form-control" placeholder="フォルダ名" aria-label="new case folder" v-model="newLawcasePrefix">
                  </div>
                  <div class="input-group">
                    <span class="input-group-text" >閲覧グループ</span>
                    <select class="form-select" aria-label="usergroup selector" v-model="selectedGroup">
                        <option v-for="userGroup in myGroups" v-bind:key="userGroup.id" :value="userGroup.id"> {{userGroup.name}} </option>
                    </select>
                  </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="onCreateLawcase">Create</button>
                    </div>
                </div>
              </div>
            </div>

            <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#filesListDialog">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
              </svg>
            </button>
            <div class="modal fade" id="filesListDialog" ref="filesListDialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">ファイル一覧</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body input-group">
                    <FileListPanel
                        :lawcaseId="showingLawcaseId"
                        :prefix="prefix"
                        :bucketname="bucketname"
                        @scan-finished="scanFinished($event)"
                    />
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <!-- <button type="button" class="btn btn-primary" @click="onCreateLawcase">Create</button> -->
                  </div>
                </div>
              </div>
            </div>
            <button class="btn btn-outline-secondary" type="button" @click="removeCase">
                <i class="bi bi-trash"></i>
            </button>
        </div>
        <div class="flex-grow-1 overflow-scroll">
            <div class="card p-1 " v-for="doc in visibleDocuments" :key="doc.id"
                role="button"
                :data-path="prefix + '/' + doc.file.path"
                :data-page="doc.start_page" 
                :ref="'docid-' + doc.id"
                @click="onDocumentSelected"
            >
                <div class="card-body">
                    <h5
                        :class="currentDocument && doc.id == currentDocument.id ? 'fw-bold' : ''"
                    >{{doc.name}}</h5>
                    <p class="card-text mb-0">
                        <span v-if="doc.is_defendant">被告</span>
                        <span v-else>原告</span>
                        {{doc.document_type.name}}
                    </p>
                    <p class="card-text mb-0" v-if="doc.doc_date">{{doc.doc_date}}</p>
                    <p class="card-text mb-0">{{doc.file.path}}</p>
                    <p class="card-text mb-0">p.{{doc.start_page + 1}}~p.{{ doc.end_page + 1}}</p>
                    <!-- <p class="card-text mb-0">{{doc.file.path}}</p> -->
                    <div v-if="currentDocument && doc.id == currentDocument.id">
                        <button class="btn btn-outline-secondary" type="button" @click.stop="showDocumentEditDialog(doc.id)">
                            <i class="bi bi-pencil"></i>編集
                        </button>
                        <button class="btn btn-outline-secondary" type="button"
                            :disabled="currentDocument && (currentDocument.start_page >= openInfo.page - 1 || currentDocument.end_page < openInfo.page - 1)"
                             @click.stop="showDocumentEditDialog()">
                            <i class="bi bi-file-earmark-plus"></i>新規挿入
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="text-center">
          <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
        </div>
        <div v-if="documents.length == 0">NO DOCUMENT</div>

        <div class="modal fade" id="documentEditDialog" ref="documentEditDialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content p-3">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">ドキュメント情報</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <h5>参照名称</h5>
                            <input type="text" class="form-control" v-model="docEditName" />
                        </div>
                        <div>
                            <h5>ドキュメント日付</h5>
                            <input type="date" class="form-control" v-model="docEditDate" />
                        </div>
                        <div>
                            <h5>ドキュメント詳細</h5>
                            <select v-model="docEditIsDefendant">
                                <option value="false">原告</option>
                                <option value="true">被告</option>
                            </select>
                            <select v-model="docEditType">
                                <option value="1">書面</option>
                                <option value="2">証拠</option>
                                <option value="3">証拠説明書</option>
                            </select>
                        </div>
                        <div>
                            <h5>終了ページ</h5>
                            <input type="number" class="form-control" :min="minPage" :max="maxPage" v-model="docEditEndPage" />
                        </div>
                        <div>
                            <input type="checkbox" class="form-check-input" v-model="docEditDisabled" />不要な文書
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" 
                            :disabled="docEditName === ''"
                             data-bs-dismiss="modal" @click="onDocumentEdit">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <button id="footer-btn"
                    type="button" 
                    class="btn btn-light toggle"
                    @click="showDisabledDoc = !showDisabledDoc" >
                {{showDisabledDoc ? '不要な書面を非表示':'不要な書面を表示' }}</button>
        </div> 
    </div>
</template>

<script>
import utils from "../utils/utils";
import FileListPanel from "../components/FileListPanel";
import {Modal} from 'bootstrap'

export default {
    name: "LeftPanel",
    components: {
        FileListPanel,
    },
    props: {
        bucketname: {type: String, required: true},
        lawcaseId: {type: Number, required: false},
        openInfo: {type: Object, required: false},
        maxPage: {type: Number, required: false},
    },
    data() {
      return {
          selectedCase: '',
          documentId: 0,
          lawcases: [],
          documents: [],
          newLawcaseName: "",
          newLawcasePrefix: "",
          showingLawcaseId: 0,
          loading: false, // should be counter, but no harm
          prefix: "",
          myGroups: [],
          selectedGroup: 0,
          filesListDialog: null,
          docEditId: null,
          docEditName: "",
          docEditDate: "",
          docEditIsDefendant: false,
          docEditType: 1,
          docEditEndPage: 0,
          docEditFileId: 0,
          docEditDisabled: false,
          minPage: 0,
          showDisabledDoc: false,
      }
    },
    async mounted() {
        let _this = this;
        this.documentEditDialog = new Modal(this.$refs.documentEditDialog);
        let e = document.getElementById("filesListDialog");
        this.filesListDialog = new Modal(e);
        e.addEventListener('shown.bs.modal', function() {
            _this.showingLawcaseId = Number(_this.selectedCase);
        });
        document.getElementById("newLawcaseDialog").addEventListener('show.bs.modal', function() {
            _this.updateMyGroups();
        });
        if(this.$store.state.userid) {
          await this.updateCaseList();
        }
        if(this.lawcaseId){
            this.selectedCase = String(this.lawcaseId);
            await this.updateDocList();
        }
    },
    unmounted(){
        console.log("++++++++++++UNMOUNTED++++++++++++++++");
    },
    methods: {
        onChangeCase(e) {
            console.log(`LeftPanel: case dropdown changed {parseInt(e.target.value)}`);
            this.$emit('case-id-changed', parseInt(e.target.value));
        },
        onDocumentSelected(e) {
            this.$emit('document-selected', { path: e.currentTarget.dataset.path, page: parseInt(e.currentTarget.dataset.page)});
        },
        onShowFilePanel(){
        },
        async onCreateLawcase() {
            this.loading = true;
            try {
                await utils.post('/api/lawcase', {name: this.newLawcaseName, path_prefix: this.newLawcasePrefix, group_id: this.selectedGroup});
                await this.updateCaseList();
                this.newLawcaseName = "";
                this.newLawcasePrefix = "";
            } finally {
                this.loading = false;
            }
        },
        async updateCaseList() {
            console.log(`LEFTPANEL: UPDATING CASE LIST`)
            console.log(`------ ${this.lawcaseId}`)
            this.loading = true;
            try {
                let gql = "{lawcase(order_by: {id:asc}) {id, name, path_prefix}}"
                let res = await utils.queryGQL(gql);
                this.lawcases = res['lawcase'];
                this.$nextTick(async function() {
                    if(!this.selectedCase && this.lawcases.length > 0){
                        //this.selectedCase = this.lawcases[0]['id'];
                        console.log('update case list');
                        this.$emit('case-id-changed', this.lawcases[0]['id']);
                    }
                });
            } finally {
                this.loading = false;
            }
        },
        async updateDocList() {
            this.loading = true;
            try {
                if(this.lawcaseId) {
                    console.log("UPDATING DOC LIST");
                    let gql = `{lawcase(where: {id: {_eq: ${this.lawcaseId}}}){
                        id, path_prefix,
                        documents(
                            order_by: {name: asc, doc_date: asc},
                        ) {
                            id, name, is_defendant, document_type {id, name}, file {id, path}, start_page, end_page, doc_date, disabled
                        }
                    }}`
                    let res = await utils.queryGQL(gql);
                    if(res.lawcase.length > 0) {
                        this.documents = res.lawcase[0].documents;
                        this.prefix = res.lawcase[0].path_prefix;
                    } else {
                        this.document = [];
                        this.prefix = "";
                    }
                }
            } finally {
                this.loading = false;
            }
        },
        async updateMyGroups() {
            this.loading = true;
            try {
                const gql = `{
                  user_group(
                    order_by: {id: asc},
                    where: {
                      deleted_at: {_is_null: true},
                    }
                  ) {
                    id,
                    name,
                    organization { id, name },
                  }
                }`;
                this.myGroups = (await utils.queryGQL(gql))['user_group'];
                if(this.myGroups && !this.selectedGroup){ this.selectedGroup = this.myGroups[0]['id']; }
            } finally {
                this.loading = false;
            }
        },
        async scanFinished(needReload){
            if(needReload){ // update doclist
                await this.updateDocList();
            }
            this.showingLawcaseId = 0;
            this.filesListDialog.hide();
        },
        async removeCase() {
            if(window.confirm("案件を削除しますか？　この操作は取り消せません")){
                this.loading = true;
                try {
                    if(this.selectedCase){
                        await utils.delete(`/api/lawcase/${this.selectedCase}`);
                    }
                    await this.updateDocList();
                } finally {
                    this.loading = false;
                }
            }
        },
        async showDocumentEditDialog(docid) {
            this.minPage = this.openInfo.page;
            if(docid){ // edit existing document
                let doc = this.documents.find(d => d.id == docid);
                this.docEditId = doc.id;
                this.docEditName = doc.name;
                this.docEditDate = doc.doc_date;
                this.docEditIsDefendant = doc.is_defendant;
                this.docEditType = doc.document_type.id;
                this.docEditEndPage = doc.end_page + 1;
                this.docEditDisabled = doc.disabled;
                this.docEditFileId = doc.file.id;
                this.minPage = doc.start_page + 1;
            } else { // create new document
                let endPage = -1;
                if(this.currentDocument) {
                    endPage = this.currentDocument.end_page +1;
                } else {
                    try {
                        this.loading = true;
                        let gql = `{document(where:{ file:{id:{_eq: ${this.openInfo.fileId}}}}){id, start_page, end_page}}`
                        let res = await utils.queryGQL(gql);
                        for(let doc in res['document'].sort((a, b) => a.start_page - b.start_page)) {
                            if(doc.start_page > this.openInfo.page) {
                                endPage = doc.start_page;
                                break;
                            }                            
                        }
                        if(endPage == -1) {
                            endPage = this.maxPage;
                        }
                    } finally {
                        this.loading = false;
                    }
                }
                this.docEditId = null;
                this.docEditName = "";
                this.docEditDate = "";
                this.docEditIsDefendant = false;
                this.docEditType = 1;
                this.docEditEndPage = endPage; // +1 is alredy done
                this.docEditDisabled = false;
                this.docEditFileId = this.openInfo.fileId;
            }
            this.documentEditDialog.show();
        },
        async onDocumentEdit() {
            this.loading = true;
            try {
                let data = {
                    name: this.docEditName,
                    // rawtxt: this.docEditName,
                    file_id: this.docEditFileId,
                    document_type_id: this.docEditType,
                    is_defendant:  this.docEditIsDefendant,
                    lawcase_id: this.lawcaseId,
                    start_page: this.openInfo.page - 1,
                    end_page: this.docEditEndPage - 1,
                    doc_date: this.docEditDate || null,
                    disabled: this.docEditDisabled,
                    is_user_modified: true,
                };
                if(this.docEditId){
                    // edit existing document
                    await utils.put(`/api/document/${this.docEditId}`, data);
                    await this.updateDocList();
                } else { // create new document
                    if(!data.rawtxt){ data.rawtxt = data.name; }
                    let res = await utils.post('/api/document', data);
                    if(this.currentDocument) {
                        await utils.put(`/api/document/${this.currentDocument.id}`, {end_page: this.openInfo.page - 2});
                    }
                    await this.updateDocList();
                    let docElem = this.$refs['docid-' + res.document_id];
                    if(docElem){ docElem[0].scrollIntoView({behaviour:"smooth"});}
                }
            } finally {
                this.loading = false;
            }
        },
    },
    computed: {
        currentDocument(){
            if(!this.openInfo.obj){ return null; }
            let openPath = this.openInfo.obj.split("/",2).pop();
            let openPage = this.openInfo.page - 1;
            let ret = this.documents.find(
                d => d.file.path == openPath && d.start_page <= openPage && d.end_page >= openPage);
            if(!ret){
                console.log(`CURRENT DOC NOT FOUND ${openPath} ${openPage}`)
                console.log(this.documents);
                return null;
            }
            console.log(`CURRENT DOC ${openPath} ${openPage} ${ret.id} ${ret.name}`)
            let docElem = this.$refs['docid-' + ret.id];
            if(docElem){ docElem[0].scrollIntoView({behaviour:"smooth"});}
            this.$emit('document-title-changed', ret.name);
            return ret;
        },
        visibleDocuments(){
            if(this.showDisabledDoc){
                return this.documents;
            } else {
                return this.documents.filter(d => !d.disabled);
            }
        }
    },
    watch: {
        async lawcaseId(newid) {
            console.log(`CASE SELECTED ${newid} ${this.lawcaseId}`)
            if(newid){
                this.selectedCase = String(newid);
                await this.updateDocList();
            } else if(this.lawcases.length > 0) {
                this.selectedCase = String(this.lawcases[0]['id']);
                await this.updateDocList();
            }
            this.$emit('document-title-changed', '');
        },
        documentId() {
            this.$emit('document-id-changed', parseInt(this.documentId));
        },
        '$store.state.userid': async function() {
            console.log("UPDATING LEFT PANE");
            await this.updateCaseList();
        },
    }
}
</script>

<style scoped>
.left-section {
    min-height: 93vh;
    padding: 1rem;
    margin-bottom: 1rem;
    border: 1px solid;
    border-radius: 5px;
    height:93vh;
}

.card  {
    margin-bottom: 1rem;
}
.input-group {
    margin-bottom: 1rem;
    width: 100%;
}
#pdf-btn {
    margin-top: 0.5rem;
}
</style>
